import { transform2px, Util } from '../utils/Commom';
import * as setSeriesConfig from '../components/setSeriesConfig';
import * as setCoordConfig from '../components/setCoordConfig';
import * as setAxisConfig from '../components/setAxisConfig';
import * as setGuideConfig from '../components/setGuideConfig';
import * as setDataConfig from '../components/setDataConfig';
import * as setAnimateConfig from '../components/setAnimateConfig';
import * as setLegentConfig from '../components/setLegendConfig';
import * as setTooltipConfig from '../components/setTooltipConfig';
import * as setPieLabelConfig from '../components/setPieLabelConfig';
var F2 = require('@antv/f2');
var CommonChart = (function () {
    function CommonChart(config) {
        this.viewInstance = {};
        this.config = Util.deepClone(config);
        this.checkChartConfig(this.config);
        this.chartInstance = new F2.Chart(this.config.chart);
    }
    CommonChart.prototype.render = function () {
        var config = this.config;
        var chart = this.chartInstance;
        this.setData(chart, config);
        this.setAxis(chart, config);
        this.setCoord(chart, config);
        this.setGuide(chart, config);
        this.setSeries(chart, config);
        this.setLegend(chart, config);
        this.setAnimate(chart, config);
        this.setTooltip(chart, config);
        this.setPieLabel(chart, config);
        this.oriConfig = config;
        chart.render();
        this.renderDefaultTooltip(chart, config);
    };
    CommonChart.prototype.repaint = function (config) {
        var newConfig = Util.deepClone(config);
        this.checkChartConfig(newConfig);
        this.renderDiffConfig(newConfig);
        this.oriConfig = newConfig;
    };
    CommonChart.prototype.destroy = function (chart) {
        chart && chart.destory();
    };
    CommonChart.prototype.clear = function (chart) {
        chart && chart.clear();
    };
    CommonChart.prototype.setData = function (chart, config) {
        return setDataConfig.process(chart, config);
    };
    CommonChart.prototype.setCoord = function (chart, config) {
        return setCoordConfig.process(chart, config);
    };
    CommonChart.prototype.setGuide = function (chart, config) {
        return setGuideConfig.process(chart, config);
    };
    CommonChart.prototype.setAxis = function (chart, config) {
        return setAxisConfig.process(chart, config);
    };
    CommonChart.prototype.setSeries = function (chart, config) {
        return setSeriesConfig.process(chart, config);
    };
    CommonChart.prototype.setAnimate = function (chart, config) {
        return setAnimateConfig.process(chart, config);
    };
    CommonChart.prototype.setLegend = function (chart, config) {
        return setLegentConfig.process(chart, config);
    };
    CommonChart.prototype.setTooltip = function (chart, config) {
        return setTooltipConfig.process(chart, config);
    };
    CommonChart.prototype.setPieLabel = function (chart, config) {
        return setPieLabelConfig.process(chart, config);
    };
    CommonChart.prototype.repaintContent = function (chart, oriConfig, config) {
        var hasChartChange = false;
        if ((!Util.isNil(oriConfig.coord) || !Util.isNil(config.coord)) &&
            !Util.isEqual(oriConfig.coord, config.coord)) {
            this.setCoord(chart, config);
            hasChartChange = true;
        }
        if ((!Util.isNil(oriConfig.legend) || !Util.isNil(config.legend)) &&
            !Util.isEqual(oriConfig.legend, config.legend)) {
            this.setLegend(chart, config);
            hasChartChange = true;
        }
        if ((!Util.isNil(oriConfig.axis) || !Util.isNil(config.axis)) &&
            !Util.isEqual(oriConfig.axis, config.axis)) {
            this.setAxis(chart, config);
            hasChartChange = true;
        }
        if ((!Util.isNil(oriConfig.guide) || !Util.isNil(config.guide)) &&
            !Util.isEqual(oriConfig.guide, config.guide)) {
            this.setGuide(chart, config);
            hasChartChange = true;
        }
        if ((!Util.isNil(oriConfig.series) || !Util.isNil(config.series)) &&
            !Util.isEqual(oriConfig.series, config.series)) {
            this.setSeries(chart, config);
            hasChartChange = true;
        }
        if ((!Util.isNil(oriConfig.animate) || !Util.isNil(config.animate)) &&
            !Util.isEqual(oriConfig.animate, config.animate)) {
            this.setAnimate(chart, config);
            hasChartChange = true;
        }
        if ((!Util.isNil(oriConfig.data) || !Util.isNil(config.data)) &&
            !Util.isEqual(oriConfig.data, config.data)) {
            this.setData(chart, config);
            hasChartChange = true;
        }
        if ((!Util.isNil(oriConfig.pieLabel) || !Util.isNil(config.pieLabel)) &&
            !Util.isEqual(oriConfig.pieLabel, config.pieLabel)) {
            this.setPieLabel(chart, config);
            hasChartChange = true;
        }
        return hasChartChange;
    };
    CommonChart.prototype.checkChartConfig = function (config) {
        var chart = config.chart;
        var chartEl;
        if (chart.id) {
            chartEl = document.getElementById(chart.id);
        }
        else if (chart.el) {
            chartEl = chart.el;
        }
        else {
            throw new Error('please set correct chart option');
        }
        var relativeWidth = chartEl.parentElement.clientWidth;
        var relativeHeight = chartEl.parentElement.clientHeight;
        var rootFontSize = Number((window.document.documentElement.style.fontSize || '').split('px')[0]);
        var width = chart.width;
        var height = chart.height;
        var padding = chart.padding;
        if (!width) {
            width = relativeWidth || 0;
        }
        else {
            width = transform2px(width, relativeWidth, rootFontSize);
        }
        if (!height) {
            height = Math.floor(3 / 4 * width);
        }
        else {
            height = transform2px(height, relativeHeight, rootFontSize);
        }
        if (padding) {
            padding = transform2px(padding, relativeWidth, rootFontSize);
            chart.padding = Util.isArray(padding) ? (padding.length ? padding : 'auto') : padding;
        }
        chart.width = width || 0;
        chart.height = height || 0;
        this.handleNotPx(config, relativeWidth, rootFontSize);
    };
    CommonChart.prototype.renderDiffConfig = function (config) {
        var oriConfig = this.oriConfig;
        var chart = this.chartInstance;
        var hasContentChange = this.repaintContent(chart, oriConfig, config);
        if (hasContentChange) {
            chart.repaint();
        }
    };
    CommonChart.prototype.handleNotPx = function (config, relativeValue, rootFontSize) {
        for (var key in config) {
            if (key !== 'el') {
                if (typeof config[key] === 'object') {
                    if (['padding'].indexOf(key) !== -1 && Util.isArray(config[key]) && config[key].length && typeof config[key][0] === 'string') {
                        config[key] = config[key].map(function (value) { return transform2px(value, relativeValue, rootFontSize); });
                    }
                    else {
                        this.handleNotPx(config[key], relativeValue, rootFontSize);
                    }
                }
                else if (['fontSize', 'radius', 'padding'].indexOf(key) !== -1) {
                    config[key] = transform2px(config[key], relativeValue, rootFontSize);
                }
            }
        }
    };
    CommonChart.prototype.renderDefaultTooltip = function (chart, config) {
        var cTooltip = Util.deepClone(config.tooltip);
        if (cTooltip && cTooltip.show && cTooltip.defaultItem) {
            var point = chart.getPosition(cTooltip.defaultItem);
            chart.showTooltip(point);
        }
    };
    return CommonChart;
}());
export default CommonChart;
//# sourceMappingURL=CommonChart.js.map